/* eslint-disable camelcase */
import React, {useState, useEffect} from 'react';
import './styles.css';
import axios from 'axios';
import NavBar from './Navbar';
import TokenManager from './TokenManager';
/* eslint "require-jsdoc": [2, {
    "require": {
        "FunctionDeclaration": true,
        "MethodDefinition": false,
        "ClassDeclaration": false
    }
}]*/
/**
* @return {html} Receipt Page.
  */


// eslint-disable-next-line require-jsdoc
function Receipt() {
  const [data, setData] = useState([]);
  const member_id = TokenManager.getId();
  useEffect(() => {
    axios.get(`https://blooming-springs-86289.herokuapp.com/api/member/receipt/${member_id}`)
        .then((response) => {
        // console.log(response)
          setData(response.data);
        });
  }, []);


  return (
    <>
      <NavBar />
      <br />

      <div>
        <div className='receiptheading'>My Receipt</div>
        <div className="container2">

          <div className="receipt">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Index</th>
                  <th scope="col">Date of addition</th>
                  <th scope="col">Product Name</th>
                  <th scope="col">Price</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => {
                  return (
                    // eslint-disable-next-line react/jsx-key
                    <tr>
                      <th scope="row">{index + 1}</th>
                      <td>{item.date_of_addition}</td>
                      <td>{item.product_name}</td>
                      <td>${item.price}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* <button onClick={calculatesumofprice}>C</button>
            <h1>Sum:{calculatesumofprice}</h1> */}

    </>
  );
};

export default Receipt;
